import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { PaletteOptions } from '@mui/material/styles/createPalette';

// Extended palette to add custom property
declare module '@mui/material/styles' {
  interface Palette {
    border: string;
  }
  
  interface PaletteOptions {
    border?: string;
  }
}

const defaultTheme = createTheme();

const border = '1px solid rgba(0, 0, 0, 0.42)';
const selectTransition = `background-color ${defaultTheme.transitions.duration.standard}ms ${defaultTheme.transitions.easing.easeInOut}`;

const theme = responsiveFontSizes(
  createTheme({
    palette: {
      border,
      primary: {
        main: '#3A3B3F',
      },
    } as PaletteOptions,
    components: {
      MuiAccordion: {
        styleOverrides: {
          root: {
            width: '100%',
            overflow: 'hidden',
            '&:before': {
              top: '0px',
            },
          },
        },
      },
      MuiAccordionSummary: {
        styleOverrides: {
          root: {
            '&.Mui-expanded': {
              transition: selectTransition,
              backgroundColor: defaultTheme.palette.grey[300],
              // boxShadow: "0px 2px 1px -1px rgba(0,0,0,0.12)"
            },
          },
          content: {
            margin: '4px 0',
            flexDirection: 'column',
            '&.Mui-expanded': {
              margin: '4px 0',
              // boxShadow: "0px 2px 1px -1px rgba(0,0,0,0.12)"
            },
          },
        },
      },
      MuiTableRow: {
        styleOverrides: {
          root: {
            minHeight: defaultTheme.typography.pxToRem(33),
            height: defaultTheme.typography.pxToRem(33),
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            whiteSpace: 'nowrap',
          },
          head: {
            whiteSpace: 'normal',
            lineHeight: 'initial',
          },
          sizeSmall: {
            padding: `0 ${defaultTheme.typography.pxToRem(10)}`,
          },
          footer: {
            color: defaultTheme.palette.text.primary,
            lineHeight: defaultTheme.typography.pxToRem(24),
            fontWeight: defaultTheme.typography.fontWeightMedium,
          },
        },
      },
    },
  })
);

export default theme;
